import DOMPurify from 'dompurify';
import { Directive } from 'vue';

export const safeHtml: Directive = {
	beforeMount(el, binding) {
		if (binding.value) {
			el.innerHTML = DOMPurify.sanitize(binding.value, {
				ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a'],
				ALLOWED_ATTR: ['href', 'target']
			});
		}
	},
	updated(el, binding) {
		if (binding.value) {
			el.innerHTML = DOMPurify.sanitize(binding.value, {
				ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a'],
				ALLOWED_ATTR: ['href', 'target']
			});
		}
	}
};
